/**
 * 面值/商品服务过滤器
 * @params Object
 *        {
 *             优惠券类型 1.满减券，2折扣券 3 兑换券
 *             couponType: String,
 *             门槛值
 *             amount: String,
 *             折扣额/折扣数
 *             discount: String,
 *             优惠券类型
 *             couponType: String,
 *             服务名称
 *             serviceName: String,
 *             单位
 *             measureUnit: String,
 *         }
 */
export default function saleAndservice({
    couponType = '',
    amount = '',
    discount = '',
    serviceName = '',
    measureUnit = '',
}) {
    let str = '';
    switch (couponType) {
    case 1:
        str = `满${amount}减${discount}`;
        break;
    case 2:
        str = `满${amount}打${discount}折`;
        break;
    case 3:
        str = `${serviceName}${discount}${measureUnit}`;
        break;
    default:
        break;
    }
    return str;
}
